import { useState, useCallback } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (method, url, data = undefined, config = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api({
        method,
        url,
        data,
        ...config,
      });
      setLoading(false);
      return response;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  }, []);

  const get = useCallback((url, config) => request('get', url, undefined, config), [request]);
  const post = useCallback((url, data, config) => request('post', url, data, config), [request]);
  const put = useCallback((url, data, config) => request('put', url, data, config), [request]);
  const patch = useCallback((url, data, config) => request('patch', url, data, config), [request]);
  const del = useCallback((url, config) => request('delete', url, undefined, config), [request]);

  return { loading, error, get, post, put, patch, del };
};

export default useApi;
